import React, { PropsWithChildren } from 'react'
import { Text } from '../../bases/Text'
import { CardSize } from './CardFrame'

const titleSize = {
  S: { fontSize: 12 },
  M: { fontSize: 14 },
  L: { fontSize: 18 },
}

export const NFTTitleText: React.FC<PropsWithChildren<{ cardSize: CardSize; text: string }>> = ({
  cardSize,
  text,
}) => {
  return (
    <Text className="flex-1 text-left font-bold text-white" style={{ ...titleSize[cardSize] }}>
      {text}
    </Text>
  )
}
